import { useAppDispatch } from '@casops/store/hooks';
import { VdsIconButton } from '@volt/volt-extended-components-react';
import { ReactElement, useCallback, useMemo } from 'react';
import { openSidePanel } from '@casops/store/slices/globalSlice';
import { ModelWithId } from '@casops/store/apis/commonModels';
import { ModelEditProps } from '../../ModelActionsCellRenderer';

interface EditActionProps<TData extends ModelWithId> extends ModelEditProps<TData> {
  data: TData;
}

export const EditAction = <TData extends ModelWithId>({
  data,
  sidePanel,
  canEditItem,
}: EditActionProps<TData>): ReactElement => {
  const dispatch = useAppDispatch();
  const modelId = data.id;

  const isEditItemAllowed = useMemo(() => {
    if (data) {
      return typeof canEditItem === 'function' ? canEditItem(data) : canEditItem;
    }
    return false;
  }, [data, canEditItem]);

  const onEdit = useCallback(() => {
    if (typeof modelId === 'number' && isEditItemAllowed) {
      dispatch(
        openSidePanel({
          sidePanel,
          modelId: modelId.toString(),
          editMode: true,
        }),
      );
    }
  }, [modelId, sidePanel, isEditItemAllowed, dispatch]);

  return (
    <VdsIconButton
      icon="edit"
      onClick={isEditItemAllowed ? onEdit : undefined}
      disabled={!isEditItemAllowed}
    />
  );
};

export default EditAction;
